import { DialogComponent } from '@theme/dialog';

class AxComparateurPopup extends DialogComponent {
  #loaded = false;

  /** @param {MouseEvent} [event] */
  showDialog(event) {
    if (event && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;

    event?.preventDefault();
    super.showDialog();
    this.#load();
  }

  async #load() {
    if (this.#loaded) return;
    this.#loaded = true;

    const { link, content: target } = this.refs;
    const src = link instanceof HTMLAnchorElement ? link.href : null;
    if (!src || !(target instanceof HTMLElement)) return;

    target.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(src);
      if (!response.ok) throw new Error(`${response.status}`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const section = doc.querySelector('.section-ax-comparateur');
      if (!section) throw new Error('section comparateur introuvable');

      await new Promise((resolve) => requestAnimationFrame(resolve));

      target.replaceChildren(...section.childNodes);
      document.dispatchEvent(new CustomEvent('reactivateLazyObserver'));
    } catch (error) {
      console.error(error);
      window.location.href = src;
    } finally {
      target.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('ax-comparateur-popup')) {
  customElements.define('ax-comparateur-popup', AxComparateurPopup);
}
